export { default as CreateEditRichMenuModal } from "./CreateEditRichMenu.vue"